<template>
  <div>
    <div class="d-flex">
      <h4 class="mr-2">{{ item.title }}</h4>
      <div>
        <span class="badge text-white bg-cr-red-black">{{ item.render_type }}</span>
      </div>
    </div>
    <table class="table table-sm">
      <tbody>
      <tr>
        <td class="text-bold">
          {{ $t('word.help_text') }}
        </td>
        <td>
          {{ item.help_text }}
        </td>
      </tr>
      <tr>
        <td class="text-bold">
          {{ $t('word.config') }}
        </td>
        <td>
          <pre class="m-0">{{ item.config }}</pre>
        </td>
      </tr>
      <tr>
        <td class="text-bold">
          {{ $tc('word.answer', 2) }}
        </td>
        <td>
          {{ item.answers_count }}
        </td>
      </tr>
      <tr>
        <td class="text-bold">
          {{ $tc('word.research', 2) }}
        </td>
        <td>
          {{ item.researches_count }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ItemDetail',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
